export const SlideShopFields = {
  id: 'id',
  productId: 'productId',
  slideMobiles: 'slideMobiles',
  slidePcs: 'slidePcs',
  productName: 'productName',
  extraInfo: 'extraInfo'
};



// WEBPACK FOOTER //
// ./src/services/slideShop/SlideShop.Constant.js